// extracted by mini-css-extract-plugin
export var card = "_9n-0";
export var expandedCard = "_9n-2";
export var paginated = "_9n-1";